import AppContext from "@/AppContext";
import { loginPopup } from "@/Atoms";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import useAuth from "@/hooks/auth";
import { BookmarkSimple } from "@phosphor-icons/react";
import { useAtom } from "jotai";
import { useContext } from "react";

const ContentWishlistComponent = ({
  item,
  content_type_name_prop,
  isDarkBackground = true,
  triggerSize,
}) => {
  const [openLoginPopup, setOpenLoginPopup] = useAtom(loginPopup);
  const { user } = useAuth();

  const { userContentWishlistIds, onRemoveContentWishlist, setWishlist } =
    useContext(AppContext);

  const handleMyWishlistClick = (e, cat_id, content_id, content_type_name) => {
    e.stopPropagation();
    if (!user) {
      setOpenLoginPopup(true);
      return;
    }

    setWishlist(
      cat_id,
      content_id,
      0,
      content_type_name_prop || content_type_name
    );
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-block rounded-full ${
              isDarkBackground ? "" : "bg-black bg-opacity-40 backdrop-blur-sm"
            }`}
          >
            {userContentWishlistIds && (
              <span
                className={`flex items-center justify-center text-white ${
                  triggerSize === "auto" ? "h-7 lg:h-9" : "size-7 lg:size-9"
                } `}
              >
                {userContentWishlistIds.includes(item.id) ? (
                  <button
                    type='button'
                    onClick={(e) => onRemoveContentWishlist(e, item.id)}
                  >
                    <BookmarkSimple
                      weight='fill'
                      color='#FFD700'
                      className='text-lg lg:text-xl'
                    />
                  </button>
                ) : (
                  <button
                    type='button'
                    className=''
                    onClick={(e) =>
                      handleMyWishlistClick(e, null, item.id, item.content_type)
                    }
                  >
                    <BookmarkSimple
                      weight='bold'
                      className='text-lg lg:text-xl'
                    />
                  </button>
                )}
              </span>
            )}
          </span>
        </TooltipTrigger>
        <TooltipContent side='top'>
          {userContentWishlistIds.includes(item.id)
            ? "Remove from bookmarks"
            : "Bookmark your favorite content so you can always find it at your fingertips."}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ContentWishlistComponent;
